import axios from 'axios';

const getPlateCheckUrls = () => {
    const baseUrl = process.env.REACT_APP_API_URL || '';
    return [
        `${baseUrl}/parkingRegister/check-plate-status`,
        `${baseUrl}/parkingregister/check-plate-status`,
    ];
};

export const cleanBackendErrorMessage = (message) => {
    if (!message || typeof message !== 'string') {
        return 'Ocurrió un error inesperado.';
    }

    return message
        .replace(/\s+con estado\s+.*$/i, '')
        .trim() || 'Ocurrió un error inesperado.';
};

export const checkPlateStatus = async (plate) => {
    const normalizedPlate = (plate || '').trim().toUpperCase();

    if (!normalizedPlate) {
        return false;
    }

    const token = localStorage.getItem('access_token');

    for (const url of getPlateCheckUrls()) {
        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { placa: normalizedPlate },
            });

            const data = Array.isArray(response?.data?.data) ? response.data.data : [];
            return data.length > 0;
        } catch (error) {
            if (error?.response?.status === 404) {
                continue;
            }

            throw error;
        }
    }

    return false;
};
